import React, { Component } from "react";
import { connect } from "react-redux";
import moment from "moment-timezone";

// Components
import ConfirmRegistrationDialog from "../utils/dialogs/ConfirmRegistrationDialog";
import BlackLink from "../utils/BlackLink";
import BlackButton from "../utils/BlackButton";
import SignedUpStatusPill from "./SignedUpStatusPill";

// CSS
import "../../css/reviews/review-preview.css";

// State
import {
	registerReviewerToRegistration,
	clearRegistrationResults
} from "../../store/actions/registration";

// Util
import { showReviewLocation } from "../../utils/reviews/reviewLocation";

class ReviewPreview extends Component {
	constructor(props) {
		super(props);
		this.state = {
			showRegistrationConfirmationDialog: false
		};
	}

	showStatus = () => {
		const { translations, review, user, hideButtons } = this.props;

		// Review is complete, don't show anything
		if (!!review.completed || !!hideButtons) {
			return null;
		}

		// ===================================
		//  Review has a registration pending for this user
		// ===================================
		if (
			user.registrations.filter(registeredReview => review.id === registeredReview.review_id)
				.length
		) {
			return (
				<BlackButton disabled={true}>
					{translations.sections.reviews.pending_label}
				</BlackButton>
			);
		}
		// ===================================
		//  Review is active for this reviewer
		// ===================================
		else if (
			user.on_site.filter(registeredReview => review.id === registeredReview.review_id)
				.length ||
			user.reading.filter(registeredReview => review.id === registeredReview.review_id).length
		) {
			return (
				<BlackLink href={`/reviews/${review.id}`}>
					{translations.sections.reviews.learn_more_label}
				</BlackLink>
			);
		}

		// ===================================
		//  Review is full & not accepting anymore reviewers
		// ===================================
		else if (review.review_full === 1) {
			return (
				<BlackButton disabled={true}>
					{translations.sections.reviews.full_label}
				</BlackButton>
			);
		}

		// ===================================
		//  Reviewer can register for this
		// ===================================
		else {
			return (
				<BlackButton
					clickHandler={() =>
						this.setState({
							showRegistrationConfirmationDialog: true
						})
					}
				>
					{translations.sections.reviews.register_label}
				</BlackButton>
			);
		}
	};

	render() {
		const { review, registration, signedUp } = this.props;
		const locationAvailable = !!review.organization_city || !!review.organization_province;
		console.log(this.props.review);

		return (
			<div className="review-preview">
				<img src={review.organization_logo} alt={review.organization_title} />
				<div className="inner">
					<div className="review-preview--content">
						{signedUp && 
							<SignedUpStatusPill type={review.on_site_id != null ? 'onSite' : 'reading'}/>
						}
						<h3>{review.organization_title}</h3>
						<h4>({review.sector_description})</h4>
						{
							review.location === "Virtual" ? <h3>Virtual Review</h3> :
								locationAvailable && <h3>{showReviewLocation(review)}</h3>
						}
						{!!review.site_visit_starts && (
							<div
								className={
									`date` + (!locationAvailable ? ` date--no-location` : ``)
								}
							>
								{moment(review.site_visit_starts)
									.local()
									.format("MMM Do, YYYY")}
									
							</div>
						)}
					</div>
					<div className="review-preview--btn-container">{this.showStatus()}</div>
				</div>

				<ConfirmRegistrationDialog
					show={this.state.showRegistrationConfirmationDialog}
					inProgress={registration.inProcess}
					id={review.id}
					itemTitle={review.organization_name}
					handleAction={() => this.props.registerReviewerToRegistration(review.id)}
					handleClose={() => {
						this.props.clearRegistrationResults();
						this.setState({ showRegistrationConfirmationDialog: false });
					}}
					errors={registration.error}
					success={registration.success}
				/>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		translations: state.translations.translations,
		registration: state.registration,
		user: state.user.reviewer.user
	};
};

export default connect(
	mapStateToProps,
	{ registerReviewerToRegistration, clearRegistrationResults }
)(ReviewPreview);



// WEBPACK FOOTER //
// ./src/components/reviews/ReviewPreview.js